__turbopack_context__.v({
  "brand": "page-module__ahHZOW__brand",
  "btn": "page-module__ahHZOW__btn",
  "card": "page-module__ahHZOW__card",
  "error": "page-module__ahHZOW__error",
  "field": "page-module__ahHZOW__field",
  "heading": "page-module__ahHZOW__heading",
  "input": "page-module__ahHZOW__input",
  "label": "page-module__ahHZOW__label",
  "subheading": "page-module__ahHZOW__subheading",
  "wrapper": "page-module__ahHZOW__wrapper",
});
